import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";

import { SortableList as AltusSortableList } from "altus-ui-components";

import { formatDate } from "utils/format.util";
import BasePage from "app/components/BasePage";
import { Format, EMPTY_MAP } from "app/app.constants";
import { getActionDataStateFromState } from "app/app.selectors";
import { ACTIONS } from "features/planner/report/report.constants";
import { SORT_DIRECTION } from "features/planner/planner.constants";
import { getScheduleOverridesReport } from "features/planner/report/report.actions";
import { workScheduleOverrideReasonToString } from "features/planner/planner.mappers";

import {
  getOverridesOfScheduleOverridesReportFromState,
  getEmployeesOfScheduleOverridesReportFromState,
} from "features/planner/report/report.selectors";

class ScheduleOverridesReportContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  columns = [
    {
      xs: true,
      title: "Employee",
      getSortProperty: item =>
        this.props.employees.getIn([
          item.get("employeeId").toString(),
          "displayName",
        ]),
      filter: {
        defaultText: "All",
      },
    },
    {
      xs: true,
      title: "Reason",
      getSortProperty: item =>
        workScheduleOverrideReasonToString(item.get("overrideReason")),
      filter: {
        defaultText: "All",
      },
    },
    {
      xs: true,
      title: "Notes",
      getSortProperty: item => item.get("notes"),
    },
    {
      xs: true,
      title: "From",
      getSortProperty: item => formatDate(item.get("startDate"), Format.date),
    },
    {
      xs: true,
      title: "To",
      getSortProperty: item => formatDate(item.get("endDate"), Format.date),
    },
  ];

  getKey = workScheduleOverride => workScheduleOverride.get("id");

  render() {
    const { breadcrumb, dataState, scheduleOverrides } = this.props;

    return (
      <BasePage title={breadcrumb} dataState={dataState}>
        <Grid container>
          <AltusSortableList
            displayNumberOfItems
            getKey={this.getKey}
            defaultSortColumn={1}
            dataState={dataState}
            columns={this.columns}
            actions={this.actions}
            items={scheduleOverrides}
            noResultsMessage="No current shedule events..."
            defaultSortDirection={SORT_DIRECTION.DESC}
          />
        </Grid>
      </BasePage>
    );
  }
}

ScheduleOverridesReportContainer.defaultProps = {
  scheduleOverrides: EMPTY_MAP,
  employees: EMPTY_MAP,
};

export default compose(
  connect(
    state => ({
      scheduleOverrides: getOverridesOfScheduleOverridesReportFromState(state),
      employees: getEmployeesOfScheduleOverridesReportFromState(state),
      dataState: getActionDataStateFromState(
        state,
        ACTIONS.GET_SCHEDULE_OVERRIDES_REPORT,
      ),
    }),
    {
      dispatchOnLoad: getScheduleOverridesReport,
    },
  ),
)(ScheduleOverridesReportContainer);
